import type { Map as MapboxMap } from "mapbox-gl";

// Layers can be added once "style.load" fires, before tiles finish. Only a non-tile error before
// that (bad token, blocked style) means the style failed; otherwise route drawing would hang.
export function waitForStyleLoadedAsync(map: MapboxMap): Promise<void> {
    if (map.isStyleLoaded())
        return Promise.resolve();

    return new Promise((resolve, reject) => {
        const onStyleLoad = () => {
            map.off("error", onError);
            resolve();
        };
        const onError = (event: { error?: Error, sourceId?: string, tile?: unknown }) => {
            if (event.sourceId || event.tile)
                return;

            map.off("style.load", onStyleLoad);
            map.off("error", onError);
            reject(event.error ?? new Error("The Mapbox style failed to load."));
        };

        map.once("style.load", onStyleLoad);
        map.on("error", onError);
    });
}
